export default "__VITE_ASSET__DnRnXmaR__"